import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { TopBar, BottomNav, Footer } from "@/components/dm/Chrome";
import { AuthDialog } from "@/components/dm/AuthDialog";
import { OutcomeBanner, InstallBanner, WelcomeBanner } from "@/components/dm/Banners";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import PostDetail from "@/pages/PostDetail";
import CreatePost from "@/pages/CreatePost";
import MyPosts from "@/pages/MyPosts";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import Admin from "@/pages/Admin";
import ShareApp from "@/pages/ShareApp";
import Flyer from "@/pages/Flyer";
import Saved from "@/pages/Saved";
import Invite from "@/pages/Invite";
import ShopLink from "@/pages/ShopLink";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const flyer = pathname === "/flyer";
  const bare = flyer || pathname.startsWith("/post/") || pathname.startsWith("/create") || pathname.startsWith("/edit");
  return (
    <div className={flyer ? "min-h-screen" : "min-h-screen pb-24"}>
      {!flyer && <div className="print:hidden"><TopBar /></div>}
      {!flyer && <WelcomeBanner />}
      <OutcomeBanner />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/create" element={<CreatePost />} />
          <Route path="/edit/:id" element={<CreatePost />} />
          <Route path="/my-posts" element={<MyPosts />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/u/:id" element={<PublicProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/share" element={<ShareApp />} />
          <Route path="/flyer" element={<Flyer />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/:slug" element={<ShopLink />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!bare && <div className="print:hidden"><Footer /></div>}
      {!flyer && <div className="print:hidden"><BottomNav /></div>}
      <AuthDialog />
      <InstallBanner />
    </div>
  );
};

export default function App() {
  useEffect(() => {
    const s = document.getElementById("dm-splash");
    if (s) { const tm = setTimeout(() => { s.style.opacity = "0"; setTimeout(() => s.remove(), 350); }, 500); return () => clearTimeout(tm); }
  }, []);
  useEffect(() => { if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {}); }, []);
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollTop />
        <Shell />
      </BrowserRouter>
      <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: 16, fontFamily: "Plus Jakarta Sans" } }} />
    </AppProvider>
  );
}
